import { useActions, useStrategy, useHartfordLevel } from '@/store/selectors';
import { NomogramSource } from '@/types';
import { Collapsible } from '@/components/shared/Collapsible';
import { Select } from 'calc-controls';
import { nomogramLabel } from '@/utils/format';

/** Nomogram source switcher — reclassifies level on change (PSD §8.2 / TODO Task 2.13). */
export function AdvancedNomogram(): JSX.Element {
  const actions = useActions();
  const strategy = useStrategy();
  const hartfordLevel = useHartfordLevel();

  return (
    <Collapsible title="Advanced nomogram options" defaultOpen={false}>
      <div className="advanced-nomogram-content" data-testid="advanced-nomogram">
        <Select
          label="Nomogram source"
          options={Object.values(NomogramSource).map((s) => ({ value: s, label: nomogramLabel(s) }))}
          value={strategy.nomogramSource}
          onChange={(v) => actions.setNomogramSource(v as NomogramSource)}
        />
        {!hartfordLevel && (
          <div className="hint-text">Enter a Hartford random level (Levels tab) to see classification.</div>
        )}
        {hartfordLevel && (
          <div className="value-row">
            <span className="value-label">Current level</span>
            <span className="value-num">
              {hartfordLevel.valueMg} mg/L @ {hartfordLevel.drawTimeHr}h
            </span>
          </div>
        )}
        <div className="hint-text">
          Switching the nomogram source reclassifies the measured level using that
          institution&apos;s boundary coordinates.
        </div>
      </div>
    </Collapsible>
  );
}
